import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/stores/auth'
import { AdminPage } from '@/features/admin/AdminPage'

/**
 * Admin section — role-gated.
 *
 * Story E01.07 AC-06: only `role === 'admin'` may enter; others are redirected
 * to `/dashboard`. The outer `_authenticated` route already enforces sign-in,
 * so the only extra check here is role.
 */
export const Route = createFileRoute('/_authenticated/admin')({
  beforeLoad: () => {
    const user = useAuthStore.getState().user
    if (user?.role !== 'admin') {
      throw redirect({ to: '/dashboard' })
    }
  },
  component: AdminPage,
})
